<template>

  <div class="link-client-cont">
    <p class="header-txt">Client Details (List all Clients, Explain contractual part from Petitioner to End-client)</p>
    <div class="timeline">
      <ul v-if="link">
        <li v-for="(t, index) in link" :key="index" :class="{'w2-link':linkTaxterm =='W2','w1099-link':linkTaxterm =='1099'}"  v-if="t !=null">
          <div class="content" v-if="t !=null && linkTaxterm !='1099' && linkTaxterm !='W2'">
            <div class="content-con">
              <div class="row m0">
                <div class="col-md-4 pL0">
                  <p class="offer-label">{{ getNameByType(t.Type) }} Name</p>
                  <ob-input disabled v-if="t.Type =='EndClient'" v-formi9-name v-model="t.OrganizationName" @input="updateValue('orgName', t.OrganizationName, index)"></ob-input>
                  <ob-input v-else :disabled="!t.IsEdit" v-formi9-name v-model="t.OrganizationName" @input="updateValue('orgName', t.OrganizationName, index)"></ob-input>
                  <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && (t.OrganizationName == null || t.OrganizationName == '') && t.IsEdit == true">Please enter {{ getNameByType(t.Type)}} name</p>
                  <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && t.IsEdit == true && $v.link.$each[index].OrganizationName.$dirty && !$v.link.$each[index].OrganizationName.required">Please enter {{ getNameByType(t.Type)}} name</p>
				          <!-- <span class="ob-vuelidate_error-msg" v-if="validate && t.IsEdit == true && $v.link.$each[index].OrganizationName.$dirty && !$v.link.$each[index].OrganizationName.required">Please enter Project Title</span> -->
                </div>

                <div class="col-md-4 pR0" >
                  <p class="offer-label">{{ getNameByType(t.Type) }} Website</p>
                  <ob-input  v-if="t.Type =='EndClient'" v-model="t.Website" @input="updateValue('siteName', t.Website, index)"></ob-input>
                  <ob-input v-else :disabled="!t.IsEdit"  v-model="t.Website" @input="updateValue('siteName', t.Website, index)"></ob-input>
                 <!-- <input class="form-control" type="text" :disabled="!t.IsEdit"  v-model="t.Website"  @input="updateValue($event.target.value)" @keydown.enter="enter" @keydown.down='down' @keydown.up='up'> -->
                   <!--<p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && t.Website == '' && t.IsEdit == true">Please enter Website</p>-->
                  <!--<p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && t.Website != '' && t.validateWebUrl == false && t.IsEdit == true">Please enter valid Website</p>-->
                  <!-- <span class="ob-vuelidate_error-msg" v-if="validate  && t.IsEdit == true && $v.link.$each[index].Website.$dirty && !$v.link.$each[index].Website.required">Please enter Website</span> -->
                  <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && t.IsEdit == true && $v.link.$each[index].Website.$dirty && !$v.link.$each[index].Website.validateUrl">Please enter Valid Website</p>
                </div>
                <div class="col-md-4 pR0">
                  <!-- <a v-if="t.IsEdit && t.Type !='EndClient'" @click="removeLink(index)" class="delete_icon"><i class="fa fa-times-circle-o" aria-hidden="true" style="font-size: 20px;color: #ff3232;"></i></a> -->


                    <ob-popover trigger="click" :options="{placement: 'bottom'}" v-if="t.IsEdit && t.Type !='EndClient'" :ref="`popoverHide${index}`" >
                        <div class="popper" style="padding:0px">
                            <div class="document-popover" style="background:#fff;padding:10px 0 0;">
                                <div style="padding:10px;display:inline-block">
                                    <p>Are you sure you want to delete this information?</p>
                                </div>
                            </div>
                            <div style="padding:10px 10px 20px">
                              <div class="pop-over-btn">
                                <ob-button type="secondary" @click="removeLink(index)">Yes</ob-button>
                              </div>
                              <ob-button type="primary" @click.native="removePopOver(index)">No</ob-button>
                                 </div>
                        </div>
                        <!-- <a v-if="t.IsEdit && t.Type !='EndClient'" slot="reference"  class="delete_icon"><i class="fa fa-times-circle-o" aria-hidden="true" style="font-size: 20px;color: #ff3232;"></i></a> -->

                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/cross-circle.svg`" width="25" height="25" slot="reference" style="cursor:pointer;display:inline-block;margin-top:35px;"/>

                    </ob-popover>
                </div>
              </div>
              <a class="Add-Cient-txt" @click="addLink(index)">
                Add {{getAddBtnName(index)}}
              </a>
            </div>
          </div>
          <div class="content w2-hide" v-else-if="t != null && linkTaxterm =='W2'">
            <div class="content-con">
              <div class="row m0" :class="{'clnt-algn':isESS == true}">
                <div class="col-md-4 pL0">
                  <p class="offer-label">{{ getNameByVendorType(t.Type) }} Name</p>
                     <ob-input v-if="t.Type =='EndClient'"  :disabled="!t.IsEdit" v-formi9-name v-model="t.OrganizationName" @input="updateValue('orgName', t.OrganizationName, index)"></ob-input>
                     <ob-input v-else :disabled="!t.IsEdit" v-formi9-name v-model="t.OrganizationName" @input="updateValue('orgName', t.OrganizationName, index)"></ob-input>
                  <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && (t.OrganizationName == null || t.OrganizationName == '') && t.IsEdit == true">Please enter {{ getNameByVendorType(t.Type) }} name</p>
                  <!-- <span class="ob-vuelidate_error-msg" v-if="validate && t.IsEdit == true && $v.link.$each[index].OrganizationName.$dirty && !$v.link.$each[index].OrganizationName.required">Please enter Project Title</span> -->
                </div>
                <div class="col-md-4 pR0" v-if="t.Type =='EndClient' || t.Type =='Client'">
                  <p class="offer-label">{{ getNameByVendorType(t.Type) }} Website</p>
                  <ob-input  v-if="t.Type =='EndClient'" :disabled="!t.IsEdit" v-model="t.Website" @input="updateValue('siteName', t.Website, index)"></ob-input>
                  <ob-input v-else :disabled="!t.IsEdit"  v-model="t.Website" @input="updateValue('siteName', t.Website, index)"></ob-input>
                  <!-- <ob-input :disabled="!t.IsEdit"  v-model="t.Website" ></ob-input> -->
                 <!-- <input class="form-control" type="text" :disabled="!t.IsEdit"  v-model="t.Website"  @input="updateValue($event.target.value)" @keydown.enter="enter" @keydown.down='down' @keydown.up='up'> -->
                  <!-- <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && t.Website == '' && t.IsEdit == true">Please enter Website</p> -->
                 <!-- <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && t.Website != '' && t.validateWebUrl == false && t.IsEdit == true">Please enter valid Website</p> -->
                  <!-- <span class="ob-vuelidate_error-msg" v-if="validate  && t.IsEdit == true && $v.link.$each[index].Website.$dirty && !$v.link.$each[index].Website.required">Please enter Website</span> -->
                  <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && t.IsEdit == true && $v.link.$each[index].Website.$dirty && !$v.link.$each[index].Website.validateUrl">Please enter Valid Website</p>
               </div>
                <div class="col-md-4 pR0":class="{'rmv-algn':isESS == true}">
                  <!-- <a v-if="t.IsEdit && t.Type !='EndClient'" @click="removeLink(index)" class="delete_icon"><i class="fa fa-times-circle-o" aria-hidden="true" style="font-size: 20px;color: #ff3232;"></i></a> -->
                   <ob-popover trigger="click" :options="{placement: 'bottom'}" v-if="t.IsEdit && t.Type !='EndClient'" :ref="`popoverHide${index}`" >
                        <div class="popper" style="padding:0px">
                            <div class="document-popover" style="background:#fff;padding:10px 0 0;">
                                <div style="padding:10px;display:inline-block">
                                    <p>Are you sure you want to delete this information?</p>
                                </div>
                            </div>
                            <div style="padding:10px 10px 20px">
                              <div class="pop-over-btn">
                                <ob-button type="secondary" @click="removeLink(index)">Yes</ob-button>
                              </div>
                              <ob-button type="primary" @click.native="removePopOver(index)">No</ob-button>
                                 </div>
                        </div>
                        <!-- <a v-if="t.IsEdit && t.Type !='EndClient'" slot="reference"  class="delete_icon"><i class="fa fa-times-circle-o" aria-hidden="true" style="font-size: 20px;color: #ff3232;"></i></a> -->

                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/cross-circle.svg`" width="25" height="25" slot="reference" style="cursor:pointer;display:inline-block;margin-top:35px;"/>

                    </ob-popover>
                </div>
              </div>
              <a class="Add-Cient-txt" @click="addcConsLink(index)">
                Add {{getAddBtnVendorName(index)}}
              </a>
            </div>
          </div>
           <div class="content" v-else-if="t != null && linkTaxterm =='1099'">
            <div class="content-con">
              <div class="row m0">
                <div class="col-md-4 pL0">
                  <p class="offer-label">{{ getNameByVendorType(t.Type) }} Name</p>
                  <!-- <ob-input disabled v-if="t.Type =='EndClient'"  v-model="t.OrganizationName"></ob-input>
                  <ob-input v-else :disabled="!t.IsEdit" v-model="t.OrganizationName"></ob-input> -->
                      <ob-input disabled v-if="t.Type =='EndClient'" v-formi9-name v-model="t.OrganizationName" @input="updateValue('orgName', t.OrganizationName, index)"></ob-input>
                 <ob-input v-else :disabled="!t.IsEdit" v-formi9-name v-model="t.OrganizationName" @input="updateValue('orgName', t.OrganizationName, index)"></ob-input>
                  <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && (t.OrganizationName == null || t.OrganizationName == '') && t.IsEdit == true">Please enter {{ getNameByVendorType(t.Type) }} name</p>
                  <!-- <span class="ob-vuelidate_error-msg" v-if="validate && t.IsEdit == true && $v.link.$each[index].OrganizationName.$dirty && !$v.link.$each[index].OrganizationName.required">Please enter Project Title</span> -->
                </div>
                <div class="col-md-4 pR0" v-if="t.Type =='EndClient' || t.Type =='Client' || t.Type =='Self'">
                  <p class="offer-label">{{ getNameByVendorType(t.Type) }} Website</p>
                  <ob-input  v-if="t.Type =='EndClient'" v-formi9-name v-model="t.Website" @input="updateValue('siteName', t.Website, index)"></ob-input>
                  <ob-input v-else :disabled="!t.IsEdit" v-formi9-name v-model="t.Website" @input="updateValue('siteName', t.Website, index)"></ob-input>
                  <!-- <ob-input :disabled="!t.IsEdit"  v-model="t.Website" ></ob-input> -->
                 <!-- <input class="form-control" type="text" :disabled="!t.IsEdit"  v-model="t.Website"  @input="updateValue($event.target.value)" @keydown.enter="enter" @keydown.down='down' @keydown.up='up'> -->
                  <!-- <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && t.Website == '' && t.IsEdit == true">Please enter Website</p> -->
                <!-- <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && t.Website != '' && t.validateWebUrl == false && t.IsEdit == true">Please enter valid Website</p> -->
                  <!-- <span class="ob-vuelidate_error-msg" v-if="validate  && t.IsEdit == true && $v.link.$each[index].Website.$dirty && !$v.link.$each[index].Website.required">Please enter Website</span> -->
                  <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && t.IsEdit == true && $v.link.$each[index].Website.$dirty && !$v.link.$each[index].Website.validateUrl">Please enter Valid Website</p>
                </div>
                <div class="col-md-4 pR0">
                  <!-- <a v-if="t.IsEdit && t.Type !='EndClient'" @click="removeLinkTen(index)" class="delete_icon"><i class="fa fa-times-circle-o" aria-hidden="true" style="font-size: 20px;color: #ff3232;"></i></a> -->
                   <ob-popover trigger="click" :options="{placement: 'bottom'}" v-if="t.IsEdit && t.Type !='EndClient'" :ref="`popoverHide${index}`" >
                        <div class="popper" style="padding:0px">
                            <div class="document-popover" style="background:#fff;padding:10px 0 0;">
                                <div style="padding:10px;display:inline-block">
                                    <p>Are you sure you want to delete this information?</p>
                                </div>
                            </div>
                            <div style="padding:10px 10px 20px">
                              <div class="pop-over-btn">
                                <ob-button type="secondary" @click="removeLinkTen(index)">Yes</ob-button>
                              </div>
                              <ob-button type="primary" @click.native="removePopOver(index)">No</ob-button>
                                 </div>
                        </div>
                        <!-- <a v-if="t.IsEdit && t.Type !='EndClient'" slot="reference"  class="delete_icon"><i class="fa fa-times-circle-o" aria-hidden="true" style="font-size: 20px;color: #ff3232;"></i></a> -->

                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/cross-circle.svg`" width="25" height="25" slot="reference" style="cursor:pointer;display:inline-block;margin-top:35px;"/>

                    </ob-popover>
                </div>
              </div>
              <a class="Add-Cient-txt" @click="addcConsLink(index)" :class="{'textContractor-space':t.Type == 'Contractor'}">
               <span :class="{'textContractor-hide':t.Type == 'Contractor' || t.Type == 'Self'}" v-if="t.Type != 'Contractor' && t.Type != 'Self'"> Add {{getAddBtnVendorName(index)}}</span>
              </a>
            </div>
          </div>
          <div class="content" v-else-if="t !=null">
            <div class="content-con">
              <div class="row m0">
                <div class="col-md-4 pL0">
                  <p class="offer-label">{{ getNameByVendorType(t.Type) }} Name</p>
                     <ob-input disabled v-if="t.Type =='EndClient'" v-formi9-name v-model="t.OrganizationName"@input="updateValue('orgName', t.OrganizationName, index)"></ob-input>
                 <ob-input v-else :disabled="!t.IsEdit" v-formi9-name v-model="t.OrganizationName" @input="updateValue('orgName', t.OrganizationName, index)"></ob-input>
                  <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && (t.OrganizationName == null || t.OrganizationName == '') && t.IsEdit == true">Please enter {{ getNameByVendorType(t.Type) }} name</p>
                  <!-- <span class="ob-vuelidate_error-msg" v-if="validate && t.IsEdit == true && $v.link.$each[index].OrganizationName.$dirty && !$v.link.$each[index].OrganizationName.required">Please enter Project Title</span> -->
                </div>
                <div class="col-md-4 pR0" v-if="t.Type =='EndClient' || t.Type =='Client'">
                  <p class="offer-label">{{ getNameByVendorType(t.Type) }} Website</p>
                  <ob-input  v-if="t.Type =='EndClient'" v-formi9-name v-model="t.Website" @input="updateValue('siteName', t.Website, index)"></ob-input>
                  <ob-input v-else :disabled="!t.IsEdit" v-formi9-name  v-model="t.Website" @input="updateValue('siteName', t.Website, index)"></ob-input>
                  <!-- <ob-input :disabled="!t.IsEdit"  v-model="t.Website" ></ob-input> -->
                 <!-- <input class="form-control" type="text" :disabled="!t.IsEdit"  v-model="t.Website"  @input="updateValue($event.target.value)" @keydown.enter="enter" @keydown.down='down' @keydown.up='up'> -->
                  <!-- <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && t.Website == '' && t.IsEdit == true">Please enter Website</p> -->
                   <!-- <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && validate === true && t.Website != '' && t.validateWebUrl == false && t.IsEdit == true">Please enter valid Website</p> -->
                  <!-- <span class="ob-vuelidate_error-msg" v-if="validate  && t.IsEdit == true && $v.link.$each[index].Website.$dirty && !$v.link.$each[index].Website.required">Please enter Website</span> -->
                  <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="validate && t.IsEdit == true && $v.link.$each[index].Website.$dirty && !$v.link.$each[index].Website.validateUrl">Please enter Valid Website</p>
              </div>
                <div class="col-md-4 pR0">
                  <!-- <a v-if="t.IsEdit && t.Type !='EndClient'" @click="removeLink(index)" class="delete_icon"><i class="fa fa-times-circle-o" aria-hidden="true" style="font-size: 20px;color: #ff3232;"></i></a> -->
                  <ob-popover trigger="click" :options="{placement: 'bottom'}" v-if="t.IsEdit && t.Type !='EndClient'" :ref="`popoverHide${index}`" >
                        <div class="popper" style="padding:0px">
                            <div class="document-popover" style="background:#fff;padding:10px 0 0;">
                                <div style="padding:10px;display:inline-block">
                                    <p>Are you sure you want to delete this information?</p>
                                </div>
                            </div>
                            <div style="padding:10px 10px 20px">
                              <div class="pop-over-btn">
                                <ob-button type="secondary" @click="removeLink(index)">Yes</ob-button>
                              </div>
                              <ob-button type="primary" @click.native="removePopOver(index)">No</ob-button>
                                 </div>
                        </div>
                        <!-- <a v-if="t.IsEdit && t.Type !='EndClient'" slot="reference"  class="delete_icon"><i class="fa fa-times-circle-o" aria-hidden="true" style="font-size: 20px;color: #ff3232;"></i></a> -->

                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/cross-circle.svg`" width="25" height="25" slot="reference" style="cursor:pointer;display:inline-block;margin-top:35px;"/>

                    </ob-popover>
                </div>
              </div>
              <a class="Add-Cient-txt" @click="addcConsLink(index)">
                Add {{getAddBtnVendorName(index)}}
              </a>
            </div>
          </div>
        </li>
      </ul>
	</div>

  </div>
</template>
<script>
import namevalidation from "Vue/Core/namevalidation.js"
import {
  required,
  minLength,
  alpha,
  email,
  numeric,
  url,
  maxLength,
  requiredIf
} from "vuelidate/lib/validators";
import { req, withParams } from "vuelidate/lib/validators/common";
const validateUrl = withParams({ type: "validateUrl" }, value => {
  return (
    !req(value) ||
    /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}$/.test(
      value
    )
  );
});

import utils from 'Vue/Core/utils.js'
export default {
  props: ["link", "isValid", "validate", "linkTaxterm","isESS"],
 data(){
   return{
     valueconstr:0
   }
 },
  created() {
    this.updateIsValid();
  },
  computed: {
    editable() {
      return this.link!=undefined && this.link!=null && this.link.filter((l) => l.IsEdit === true)
    },
    // dataConstructoe(){
    //    if(this.editable.length > 0) {
    //        let classe = false
    //     this.editable.forEach((e) => {
    //       if (e.Type == 'Contractor'){
    //           this.valueconstr++
    //         if(this.valueconstr > 0){
    //           classe = true
    //         }
    //         else{
    //           classe = false
    //         }
    //       }
    //    });
    //    return classe
    //    }
    // }

  },
  watch: {
    editable: {
      handler(val) {
        this.updateIsValid()
      },
      deep: true
    }
  },
  validations() {
        return {
          link: {
                  $each: {
                    OrganizationName: {
                      required
                    },
                    Website:{
                      validateUrl
                    }
              }
          }
        }
  },
  methods: {
    updateValue(modelName, value, index){
      let val = namevalidation.getValidName(value);
      if(modelName == "orgName")
        this.link[index].OrganizationName = val
      else
        this.link[index].Website = val
    },
    updateIsValid() {
        //
      let isValid = true;
       this.$v.link.$touch();
        if(this.$v.link.$invalid === true) {
          isValid = false
        }
      if(this.editable != null && this.editable.length > 0) {
        this.editable.forEach((e) => {
          if(utils.IsNullOrEmpty(e.OrganizationName)) {
            isValid = false;
          }
          // if((this.linkTaxterm !='1099') && (e.Type == 'EndClient' || e.Type == 'Client'|| e.Type == 'Vendor')){
          // if(utils.IsNullOrEmpty(e.Website)) {
          //   isValid = false;
          // }
          // }
          // if((e.Website != '' || e.Website == '')) {
          //    let exp= /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/.test(e.Website);
          //    if(exp){
          //     this.$set(e,'validateWebUrl',true);
          //     isValid = true;
          //    }
          //    else{
          //     isValid = false;
          //     this.$set(e,'validateWebUrl',false);
          //    }
          //   }
          // }
        })
      }

      this.$emit('update:isValid', isValid);
    },
    addLink(index) {
      let obj = {
        IsEdit: true,
        OrganizationName: '',
        Type: 'Vendor',
        Website: ''
      };

      if(this._getSelfIndex() > index) {
        // Client
        obj.Type = 'Client'
      }

      this.link.splice(index + 1, 0, obj);
    },
    addcConsLink(index){
       let obj = {
        IsEdit: true,
        OrganizationName: '',
        Type: 'Contractor',
        Website: ''
      };

      if(this._getSelfVendorIndex() > index) {
        // Client
        obj.Type = 'Client'
      }

      this.link.splice(index + 1, 0, obj);

    },

    removeLink(index) {
      this.link.splice(index, 1);
      let vaee = `popoverHide${index}`
      this.$refs[vaee][0].doClose()
    },
     removeLinkTen(index) {
       this.valueconstr--
      this.link.splice(index, 1);
      let vaee = `popoverHide${index}`
      this.$refs[vaee][0].doClose()
    },
    getNameByVendorType(type) {
	 if(type != null){
      type = type.toLowerCase();
      return type == "endclient"
        ? "End Client"
        : type == "client"
          ? "Client"
          : type == "self" ? "Your Organization" : "Contractor";
		  }
    },
    getAddBtnVendorName(index){
      if(this._getSelfVendorIndex() > index) {
        return 'Client'
      } else {
        return 'Contractor'
      }
    },
    _getSelfVendorIndex() {
      if(this.link) {
        return this.link.findIndex((c) => c.Type.toLowerCase() == 'self')
      } else {
        return 0
      }
    },

    getNameByType(type) {
      type = type.toLowerCase();
      return type == "endclient"
        ? "End Client"
        : type == "client"
          ? "Client"
          : type == "self" ? "Your Organization" : "Vendor";
    },

    getAddBtnName(index) {
      if(this._getSelfIndex() > index) {
        return 'Client'
      } else {
        return 'Vendor'
      }
    },

    _getSelfIndex() {
      if(this.link) {
        return this.link.findIndex((c) => c.Type.toLowerCase() == 'self')
      } else {
        return 0
      }
    },
    removePopOver(index){
      let vaee = `popoverHide${index}`
      this.$refs[vaee][0].doClose()
      }
    // prevent(){
    //
    //   let isValid = true;
    //    if(this.editable.length > 0) {
    //     this.editable.forEach((e) => {
    //       if(utils.IsNullOrEmpty(e.Website)) {
    //         isValid = false;
    //         let exp= /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/.test(e.Website);
    //          if(exp){

    //            alert("validation true")
    //         isValid = false;
    //       }
    //       else{
    //         alert("validation fail")
    //         isValid = false;
    //       }
    //       }
    //     })
    //   }
    // }
  }
};
</script>
<style lang="scss" scoped>
@import "~styles/framework/vue-utils";
*,
*::before,
*::after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.m0 {
  margin: 0 !important;
}

.p0 {
  padding: 0 !important;
}

.timeline {
  color: black;
  background: #fff;
  padding: 20px 0 10px;
  ul {
    margin: 0 10px;
    padding: 22px 0;
    li {
      background: #eee;
      position: relative;
      margin: 0;
      width: 2px;
      padding-bottom: 0px;
      list-style-type: none;
      &:before {
        content: "+";
        background: #fff;
        position: absolute;
        left: 50%;
        line-height: 16px;
        padding-left: 4px;
        font-size: 18px;
        top: 38%;
        transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        width: 20px;
        height: 20px;
        color: #4a90e2;
        border: 1px solid #4a90e2;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
      }
      .hidden {
        opacity: 0;
      }
      .content {
        background: #fff;
        position: relative;
        top: 7px;
        width: 606px;
        padding: 0px;
        &:before {
          content: "";
          background: #eee;
          position: absolute;
          top: 0px;
          width: 20px;
          height: 2px;
        }
      }
      .content {
        left: 19px;
        top: 0;
      }
      .content:before {
        left: -18px;
      }
    }
  }
}

li {
  &:last-child {
    background: #eee;
    position: relative;
    margin: 0 auto;
    width: 2px;
    padding-bottom: 0px;
    list-style-type: none;
    height: 50px;
    &:before {
      content: "+";
      background: #fff;
      position: absolute;
      left: 50%;
      line-height: 16px;
      padding-left: 4px;
      font-size: 18px;
      top: 73% !important;
      transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      width: 20px;
      height: 20px;
      color: #4a90e2;
      border: 1px solid #4a90e2;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
    }
  }
  .hidden {
    opacity: 0;
  }
}
.w2-link {
  &:last-child {
    background: #eee;
    position: relative;
    width: 2px;
    padding-bottom: 0px;
    list-style-type: none;
    height: 0px;
    &:before {
      content: "+";
      background: #fff;
      position: absolute;
      left: 50%;
      line-height: 16px;
      padding-left: 4px;
      font-size: 18px;
      top: 73% !important;
      transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      width: 20px;
      height: 20px;
      color: #4a90e2;
      border: 1px solid #4a90e2;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      display:none;
    }
    .w2-hide{
      .Add-Cient-txt{
        display:none

      }


    }
  }
  .hidden {
    opacity: 0;
  }
}
 .textContractor-space{
    padding-bottom: 0 !important;
  }
.textContractor{
  .textContractor-hide{
  display:none !important;
  padding-bottom: 0 !important;
  }

}
.textContractor{
  &:last-child {
    background: #eee;
    position: relative;
    width: 2px;
    padding-bottom: 0px;
    list-style-type: none;
    height: 0px;
    &:before {
      content: "+";
      background: #fff;
      position: absolute;
      left: 50%;
      line-height: 16px;
      padding-left: 4px;
      font-size: 18px;
      top: 73% !important;
      transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      width: 20px;
      height: 20px;
      color: #4a90e2;
      border: 1px solid #4a90e2;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      display:none;
    }
    .w2-hide{
      .Add-Cient-txt{
        display:none

      }


    }
  }
  .hidden {
    opacity: 0;
  }

}
.w1099-link {
  &:last-child {
    background: #eee;
    position: relative;
    width: 2px;
    padding-bottom: 0px;
    list-style-type: none;
    height: 0px;
    &:before {
      content: "+";
      background: #fff;
      position: absolute;
      left: 50%;
      line-height: 16px;
      padding-left: 4px;
      font-size: 18px;
      top: 73% !important;
      transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      width: 20px;
      height: 20px;
      color: #4a90e2;
      border: 1px solid #4a90e2;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      display:none;
    }
  }
  .hidden {
    opacity: 0;
  }
}
.content-con {
    position: relative;
    top: -45px; /* added top -45 for viewing in DEMo*/
}

.Add-Cient-txt {
  margin: 0;
  display: inline-block;
  margin-left: 0px;
  margin-top: 0px;
  padding-bottom: 23px;
  font-weight: 600;
  font-size: 12px;
  font-style: italic;
  transform: translateY(11px);
  color: #4a90e2;
  padding-top:10px;
}
.client_text-field {
  height: 30px;
}
.client-label {
  color: #5c5c5c !important;
  font-size: 12px !important;
  font-weight: 600;
}

.delete_icon {
  display: block;
  padding-top: 22px;
  position: relative;
}
.header-txt {
   color: #000;
   font-weight: 700;
   font-size: 13px;
   padding: 20px 0px 15px 15px;
}

.ob-vuelidate_error-msg {
    color: #d60000;
    position: fixed;
}
.pop-over-btn{
    display: inline;
    padding-right: 10px;
}
@media screen and (max-width: 1020px) {
  .timeline ul li .content {
    width: 64vw;
  }
}

@media screen and (max-width: 700px) {
  .timeline ul li {
    margin-left: 20px;
    .content {
      width: calc(100vw - 100px);
      h2 {
        text-align: initial;
      }
    }
    .content:before {
      left: -18px;
    }
  }
}
.clnt-algn{
  padding-top:13px;
}
.rmv-algn{
  margin-top:-15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/ESSProjects/EmpLinkToEndClient.vue